"use client";
import {JSX, useState} from "react";

import {ButtonBase} from "@/shared/ui/buttons";
import {ButtonSimple} from "@/shared/ui/buttons";
import {Modal} from "@/shared/ui/overlay/modal/modal";

import "./styles/owner-login-modal.scss";

const STREAMLINE_URL = "https://login.casago.com/login?_gl=1*1rhtjgy*_gcl_au*MTcyMDI4NDE3My4xNzY4MzIwNDky";
const GUESTY_URL = "https://app.guesty.com/auth/login/";

interface OwnerLoginModalProps {
    label: string;
    modalTitle: string;
    streamlineLabel: string;
    guestyLabel: string;
}

export function OwnerLoginModal({label, modalTitle, streamlineLabel, guestyLabel}: OwnerLoginModalProps): JSX.Element {
    const [isOpen, setIsOpen] = useState(false);

    const handleOpen = (): void => {
        setIsOpen(true);
    };

    const handleClose = (): void => {
        setIsOpen(false);
    };

    const handleSelect = (url: string): void => {
        window.open(url, "_blank", "noopener,noreferrer");
        setIsOpen(false);
    };

    return (
        <>
            <ButtonSimple as="button" size="sm" variant="secondary" onClick={handleOpen} className="owner-login-trigger">
                {label}
            </ButtonSimple>

            <Modal
                isOpen={isOpen}
                onClose={handleClose}
                className="owner-login-modal"
                contentClassName="owner-login-modal__content"
                ariaLabel="Owner Login"
                closeOnBackdropClick
            >
                <div className="owner-login-modal__body">
                    <h3 className="owner-login-modal__title">{modalTitle}</h3>
                    <div className="owner-login-modal__buttons">
                        <ButtonBase as="button" variant="primary" size="lg" width="full" onClick={() => handleSelect(STREAMLINE_URL)}>
                            {streamlineLabel}
                        </ButtonBase>
                        <ButtonBase as="button" variant="primary" size="lg" width="full" onClick={() => handleSelect(GUESTY_URL)}>
                            {guestyLabel}
                        </ButtonBase>
                    </div>
                </div>
            </Modal>
        </>
    );
}
